import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ProjectTemplateProjectPhase } from 'data/templates/projects';
import {
  addPhaseAboveInProjectTemplate,
  deletePhaseInProjectTemplate,
  shiftStartDayOfProjectPhaseInProjectTemplate,
  updatePhaseInProjectTemplate,
} from 'data/templates/projects/actions';

export const useTemplateProjectPhaseCommonActions = (
  projectPhase: ProjectTemplateProjectPhase,
): {
  onTogglePrivate(): void;
  onUpdateName(name: string): Promise<void>;
  onDeleteProjectPhase(): void;
  onShiftStartDay(shiftBy: number): void;
  addPhaseAbove(): void;
} => {
  const dispatch = useDispatch();

  const update = useCallback(
    (payload: Partial<ProjectTemplateProjectPhase>) => {
      dispatch(
        updatePhaseInProjectTemplate({
          projectPhaseId: projectPhase.projectPhaseId,
          payload,
        }),
      );
    },
    [dispatch, projectPhase],
  );

  const onTogglePrivate = useCallback(() => {
    update({
      private: !projectPhase.private,
    });
  }, [update, projectPhase]);

  const onUpdateName = useCallback(
    async (projectPhaseName: string) => {
      update({
        projectPhaseName,
      });
    },
    [update],
  );

  const onDeleteProjectPhase = useCallback(() => {
    dispatch(deletePhaseInProjectTemplate(projectPhase));
  }, [dispatch, projectPhase]);

  const onShiftStartDay = useCallback(
    (shiftBy: number) => {
      dispatch(
        shiftStartDayOfProjectPhaseInProjectTemplate({
          projectPhaseId: projectPhase.projectPhaseId,
          shiftBy,
        }),
      );
    },
    [dispatch, projectPhase],
  );

  const addPhaseAbove = useCallback(() => {
    dispatch(
      addPhaseAboveInProjectTemplate({
        projectPhaseId: projectPhase.projectPhaseId,
      }),
    );
  }, [dispatch, projectPhase]);

  return {
    onTogglePrivate,
    onUpdateName,
    onDeleteProjectPhase,
    onShiftStartDay,
    addPhaseAbove,
  };
};
